// extracted by mini-css-extract-plugin
export default {"root":"Opener_root__3VCVg"};